import { Document, Page, Text, View, StyleSheet } from '@react-pdf/renderer';


import { style } from '../../../components/pdf/fontstyles';
import { AutoText } from '../../../components/pdf/autoText';


const styles = StyleSheet.create({
 
  table: {
    marginTop: 10,
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
  },
  row: {
    flexDirection: 'row',
    borderBottom: '1px solid #000',
  },
  cell: {
    padding: 5,
    borderRight: '1px solid #000',
  },
  headerCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
  },
  // Column specific styles (adjust widths for each column)
  srNoCell: {
    width: '40%', // First column with smaller width
  },
  detailsCell: {
    width: '60%', // Second column with larger width
  },
 




   // Special merged cell for row 18
   mergedCell: {
    padding: 5,
    width: '100%',
    borderRight: 'none',
    borderLeft: 'none',
  },
  nestedTable: {
    display: 'table',
    width: '100%',
    borderStyle: 'solid',
    borderWidth: 1,
    borderColor: '#000',
    borderCollapse: 'collapse',
    marginTop: 5,
    marginBottom: 5,
  },
  nestedRow: {
    flexDirection: 'row',
  },
  nestedHeaderCell: {
    fontWeight: 'bold',
    backgroundColor: '#f2f2f2',
    padding: 3,
    textAlign: 'center',
    borderRight: '1px solid #000',
    borderBottom: '1px solid #000',
    fontSize: 8,
  },
  nestedCell: {
    padding: 3,
    borderRight: '1px solid #000',
    borderBottom: '1px solid #000',
    textAlign: 'center',
    fontSize: 8,
  },
  // Equal width for all 6 columns
  nestedCol: {
    width: '25%',
  },
  nestedCol1: { width: '30%' },   // Month column - wider
  nestedCol2: { width: '30%' },   // Basic Pay
  nestedCol3: { width: '40%' },   // Grade Pay


});

const PensionAnnexure = ({ result }) => {



  const tableData1 = [
    ['10 digit DDO Code', result.ddoCode],
    ['Class of Pension', result.typeOfRetirement],
    ['Name', result.employeeName],
    ['Sex', result.gender],
    ['Designation', result.designation],
    ['Group / Class:', result.classOfPost],
    ['Employee Code No & Sevaarth ID', result.employeecode],
    ['Employee’s Personal Details', 
      (
        <View style={{ width: '100%', flexDirection: 'column' }}>
          <Text style={{ marginBottom: 5 }}>Employee’s Personal Details</Text>
          <View style={styles.nestedTable}>
            <View style={styles.nestedRow}>
              <Text style={[styles.nestedHeaderCell, styles.nestedCol1]}>Aadhar No</Text>
              <Text style={[styles.nestedHeaderCell, styles.nestedCol2]}>PAN Number</Text>
              <Text style={[styles.nestedHeaderCell, styles.nestedCol3]}>e-mail ID</Text>
            </View>
            <View style={styles.nestedRow}>
              <Text style={[styles.nestedCell, styles.nestedCol1]}>{result.adharno}</Text>
              <Text style={[styles.nestedCell, styles.nestedCol2]}>{result.panno}</Text>
              <Text style={[styles.nestedCell, styles.nestedCol3]}>{result.email}</Text>
            </View>
          </View>
        </View>
      ),
    ],
    ['a)	Address Before retirement', result.address],
    ['b)	Address After retirement', 'as above'],
    ['Date of submission of pension :', ''],
    ['Department', 'Higher & Technical  Education, Maharshtra'],
    ['Place / District of Retirement:', result.placeOfRetirement],
    ['DDO Retired from:', result.ddoretired],
    ['T.O. for DCRG::', result.todcrg],
  ];
  const tableData2 = [
      [result.bankName, result.branchName, result.ifscCode, result.accountNumber],
  ];
  
  const tableData3 = [
      ['Date of Birth', result.dateOfBirth, 'Date of Appointment', result.dateOfAppointment],
      ['Date of commencement of Pensionable Service',  result.dateOfAppointment, 'Date of Retirement ', result.dateOfRetirement],
  
  ];
  
 
  
  







return (
  <View style={style.page}>
    <Text style={[style.title , style.ArialBlack]}>Annexure A - Departmental Data Sheet</Text>
    <View style={style.solidLine}></View>


       <View style={styles.table}>
       {tableData1.map(([srNo, details], index) => (
    <View style={styles.row} key={index}>
      {srNo === 'Employee’s Personal Details' ? (
        <View style={[styles.mergedCell, { width: '100%' }]}>
          {details}
        </View>
      ) : (
        <>
          <Text style={[styles.cell, styles.srNoCell]}>{srNo}</Text>
          <AutoText style={[styles.cell, styles.detailsCell]}>{details}</AutoText>
        </>
      )}
    </View>
  ))}
        </View>

    <Text style={{fontSize: 10, marginTop: 5, marginBottom: 1 }}>Bank Details:</Text>





     {/* Table */}
     <View style={[styles.table ,{ marginTop: 0 }]}>
      {/* Header Row */}
      <View style={[styles.row, styles.headerCell]}>
        <Text style={[styles.cell, styles.nestedCol]}>Bank Name</Text>
        <Text style={[styles.cell, styles.nestedCol]}>Bank Branch</Text>
        <Text style={[styles.cell, styles.nestedCol]}>IFSC code:</Text>
        <Text style={[styles.cell, styles.nestedCol]}>Bank A/c No.</Text>
      </View>
      
       {/* Table Data */}
       {tableData2.map(([BankName, bankbranch, ifsccode, bankAC], index) => (
        <View style={styles.row} key={index}>
          <Text style={[styles.cell, styles.nestedCol]}>{BankName}</Text>
          <Text style={[styles.cell, styles.nestedCol]}>{bankbranch}</Text>
          <Text style={[styles.cell, styles.nestedCol]}>{ifsccode}</Text>
          <Text style={[styles.cell, styles.nestedCol]}>{bankAC}</Text>
        </View>
      ))}
    </View>

    <Text style={{fontSize: 10, marginTop: 5, marginBottom: 1 }}>GPF Account No. allotted by A.G. Office : {result.pfno}</Text>
     {/* Table */}
     <View style={[styles.table ,{ marginTop: 0 }]}>
      
       {/* Table Data */}
       {tableData3.map(([text1, value1, text2, value2], index) => (
        <View style={styles.row} key={index}>
          <Text style={[styles.cell, styles.nestedCol]}>{text1}</Text>
          <Text style={[styles.cell, styles.nestedCol]}>{value1}</Text>
          <Text style={[styles.cell, styles.nestedCol]}>{text2}</Text>
          <Text style={[styles.cell, styles.nestedCol]}>{value2}</Text>
        </View>
      ))}
    </View>

  </View>
)};

export default PensionAnnexure;
